import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { login, setToken } from "@/lib/api";

const formatDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail.msg || detail);
};

export const OwnerLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const signInWithGoogle = () => {
    const redirectUrl = window.location.origin + "/owner";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await login(email.trim(), password);
      setToken(data.token);
      onSuccess(data.user);
      toast.success("Signed in");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-start justify-center px-6 py-24" data-testid="owner-login">
      <div className="w-full max-w-sm">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm bg-white border border-[#E5E5E5] rounded-md p-8"
        style={{ fontFamily: "Outfit, sans-serif" }}
      >
        <Lock size={20} className="text-[#0F2A52]" />
        <h1 className="text-xl font-medium text-[#111111] mt-4">Owner sign in</h1>
        <p className="text-sm text-neutral-500 mt-2 mb-7">
          Private area for PARADISIO RESORTS photos and enquiries.
        </p>

        <label className="block text-xs uppercase tracking-wider text-neutral-500 mb-2">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-[#E5E5E5] rounded-md px-3 py-2.5 text-sm mb-5 focus:outline-none focus:border-[#0F2A52]"
          data-testid="owner-login-email"
        />

        <label className="block text-xs uppercase tracking-wider text-neutral-500 mb-2">Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border border-[#E5E5E5] rounded-md px-3 py-2.5 text-sm mb-7 focus:outline-none focus:border-[#0F2A52]"
          data-testid="owner-login-password"
        />

        <button
          type="submit"
          disabled={busy}
          className="w-full inline-flex items-center justify-center gap-2 bg-[#0F2A52] text-white rounded-md px-4 py-2.5 text-sm disabled:opacity-60"
          data-testid="owner-login-submit"
        >
          {busy && <Loader2 size={15} className="animate-spin" />}
          {busy ? "Signing in" : "Sign in"}
        </button>
      </form>
      <button
        type="button"
        onClick={signInWithGoogle}
        className="mt-4 w-full flex items-center justify-center gap-3 bg-white border border-[#E5E5E5] rounded-md px-4 py-3 text-base text-[#111111] hover:border-[#0F2A52] transition-colors duration-200"
        data-testid="owner-google-signin"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
          <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92a8.78 8.78 0 0 0 2.68-6.62Z" />
          <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86a5.36 5.36 0 0 1-5.03-3.71H1.03v2.33A9 9 0 0 0 9 18Z" />
          <path fill="#FBBC05" d="M3.97 10.71a5.4 5.4 0 0 1 0-3.42V4.96H1.03a9 9 0 0 0 0 8.08l2.94-2.33Z" />
          <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59A9 9 0 0 0 1.03 4.96l2.94 2.33A5.36 5.36 0 0 1 9 3.58Z" />
        </svg>
        Sign in with Google
      </button>
      <p className="text-xs text-neutral-500 mt-3 text-center">
        Only approved Paradisio Resorts accounts can sign in.
      </p>
      </div>
    </div>
  );
};

export default OwnerLogin;
